import React from "react";

import getConfig from "next/config";
import Container from "ui/Container/Container";
import Grid from "ui/Grid/Grid";
import Slider from "common/Slider/Slider";
import ChevronRightRound from "assets/icons/chevron-right-round.svg";

import { useUrl } from "helpers/hooks";
import Item from "./components/Item/Item";
import styles from "./Blog.module.scss";

const { publicRuntimeConfig } = getConfig();

type Props = {
  title: string;
  articles: Array<Entity.Blog.Article>;
  categories: Array<Entity.Blog.Category>;
};

const Blog: React.FC<Props> = ({ title, articles, categories }: Props) => {
  const { getEntityLinkProps } = useUrl();
  return (
    <section className={styles.homeBlog}>
      <Container>
        <div className={styles.homeBlogTitle}>
          {title}
          <a
            className={styles.homeBlogMore}
            href={publicRuntimeConfig.BLOG_URL}
            target="_blank"
            rel="noreferrer"
          >
            Все статьи
            <ChevronRightRound />
          </a>
        </div>

        {categories.length > 0 && (
          <div className={styles.homeBlogLinks}>
            {categories.map(item => (
              <a
                key={item.id}
                className={styles.homeBlogLinksItem}
                href={getEntityLinkProps("article", item).href as string}
                target="_blank"
                rel="noreferrer"
              >
                {item.name}
              </a>
            ))}
          </div>
        )}

        <div className={styles.homeBlogSliderContainer}>
          <Slider
            spaceBetween={20}
            pagination={{
              el: ".blog-slider-pagination",
              clickable: true,
            }}
            centeredSlides
            loop
            lazy
          >
            {articles.map((article, index) => (
              <Item
                key={article.id}
                article={article}
                type={index !== 0 ? "vertical" : "default"}
              />
            ))}
          </Slider>

          <div className="blog-slider-pagination" />
        </div>

        <div className={styles.homeBlogList}>
          <Grid container spacing={10} spacingLg={20}>
            {articles.map((article, index) => (
              <Grid
                key={index}
                item
                md={index === 0 ? 12 : 6}
                lg={index === 0 ? 6 : 3}
              >
                <Item
                  article={article}
                  type={index === 2 ? "vertical" : "default"}
                />
              </Grid>
            ))}
          </Grid>
        </div>
      </Container>
    </section>
  );
};

export default Blog;
